import React from "react";

const fmtQty = (q) => (Number.isInteger(Number(q)) ? Number(q) : Number(q || 0).toFixed(2));

// Compact item list for list-page rows so orders can be read without opening them
export function OrderItemsCell({ items = [], docId, max = Infinity }) {
  const list = items.filter(i => (i.name || i.description || "").trim());
  if (list.length === 0) return <span className="text-ink-muted/60 text-xs" data-testid={`items-empty-${docId}`}>No items</span>;
  const shown = max === Infinity ? list : list.slice(0, max);
  const rest = list.length - shown.length;
  return (
    <ul className="space-y-1.5 text-base leading-snug" data-testid={`items-cell-${docId}`}>
      {shown.map((i, idx) => (
        <li key={`${docId}-${i.product_id || ""}-${i.name}-${idx}`} className="flex items-baseline gap-1.5 flex-wrap">
          <span className="font-semibold text-ink">{i.name || i.description}</span>
          <span className="text-ink-muted tabular whitespace-nowrap">× {fmtQty(i.quantity)} {i.unit || ""}</span>
          {i.description && i.name && <span className="text-ink-muted/80 basis-full">{i.description}</span>}
        </li>
      ))}
      {rest > 0 && <li className="text-ink-muted italic" data-testid={`items-more-${docId}`}>+{rest} more item{rest > 1 ? "s" : ""}</li>}
    </ul>
  );
}

// Delivery date pill — red when overdue on an open order, amber when due within 3 days
export function DeliveryDateCell({ date, status, docId }) {
  if (!date) return <span className="text-ink-muted/60 text-xs" data-testid={`delivery-${docId}`}>Not set</span>;
  const open = !["completed", "cancelled", "rejected"].includes((status || "").toLowerCase());
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const d = new Date(date + "T00:00:00");
  const days = Math.round((d - today) / 86400000);
  let cls = "text-ink";
  let hint = "";
  if (open && days < 0) { cls = "text-destructive font-semibold"; hint = `${-days}d overdue`; }
  else if (open && days <= 3) { cls = "text-amber-600 font-semibold"; hint = days === 0 ? "today" : `in ${days}d`; }
  const label = d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  return (
    <span className={`whitespace-nowrap tabular ${cls}`} data-testid={`delivery-${docId}`} data-days={days}>
      {label}{hint && <span className="block text-[10px] font-normal opacity-80">{hint}</span>}
    </span>
  );
}
